'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var markedRenderer = new _marked2.default.Renderer({
    breaks: false,
    sanitize: true
});

// https://github.com/chjj/marked/blob/master/lib/marked.js#L869
markedRenderer.link = function (href, title, text) {
    var externalLink = /^https?:\/\//i.test(href);
    if (this.options.sanitize) {
        try {
            var prot = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
            if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
                return '';
            }
        } catch (e) {
            return '';
        }
    }
    var out = '<a href="' + href + '"';
    if (title) {
        out += ' title="' + title + '"';
    }
    if (externalLink) {
        out += ' target="_blank"';
    }
    out += '>' + text + '</a>';
    return out;
};

exports.default = markedRenderer;


//////////////////
// WEBPACK FOOTER
// ./common/core/markedRenderer.js
// module id = 25
// module chunks = 0